/**
 * The id of every record the API returns: a UUIDv7 string.
 *
 * Never a number. Nothing may be read from its value or its order: a record
 * made on a device or on the hall server carries an id the cloud did not
 * choose (docs/zivy-provoz-soutezi.md R6). The ČNSMS ID, the ČP and the
 * startovní číslo are numbers and stay `number`; they are not ids.
 */
export type ID = string;

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
const NIL = "00000000-0000-0000-0000-000000000000";

/**
 * True for the canonical text of a real id: 36 characters, hyphenated, not
 * the all-zero UUID. Twin of `models.ParseID` plus its `IsZero` check in
 * Go, so a URL parameter the client keeps is one the server accepts.
 */
export function isID(value: string | null | undefined): value is ID {
  return !!value && UUID.test(value) && value !== NIL;
}
